"use client"

import { useEffect, useState } from "react"

export function StructuredData() {
  const [siteUrl, setSiteUrl] = useState("")

  useEffect(() => {
    setSiteUrl(window.location.origin)
  }, [])

  // Don't render until we have the URL (prevents hydration mismatch)
  if (!siteUrl) return null

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Loop Home",
    url: siteUrl,
    logo: `${siteUrl}/images/loop_home_long.png`,
    description: "Pre-loved vintage furniture marketplace in London with AI-powered search and delivery included.",
    sameAs: [],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      availableLanguage: "English",
    },
  }

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Loop Home",
    url: siteUrl,
    description: "Pre-loved vintage furniture marketplace with AI-powered intelligent search",
    // TODO: Uncomment when /search route is public
    // potentialAction: {
    //   "@type": "SearchAction",
    //   target: {
    //     "@type": "EntryPoint",
    //     urlTemplate: `${siteUrl}/search?q={search_term_string}`,
    //   },
    //   "query-input": "required name=search_term_string",
    // },
  }

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Loop Home",
    description: "Pre-loved and vintage furniture marketplace serving London and the UK",
    url: siteUrl,
    areaServed: {
      "@type": "City",
      name: "London",
    },
    priceRange: "££",
    image: `${siteUrl}/images/loop_home_long.png`,
  }

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is Loop Home?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Loop Home is a pre-loved furniture marketplace that connects buyers with London's best vintage furniture dealers. We use AI-powered intelligent search to help you find the perfect piece, and all purchases include delivery.",
        },
      },
      {
        "@type": "Question",
        name: "Does Loop Home include delivery?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes! All purchases from Loop Home include delivery. We handle the logistics so you can focus on finding the perfect vintage piece.",
        },
      },
      {
        "@type": "Question",
        name: "What kind of furniture does Loop Home sell?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Loop Home offers curated pre-loved and vintage furniture including mid-century modern, Scandinavian, Art Deco, and designer pieces. We source from trusted vintage dealers across London.",
        },
      },
    ],
  }

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  )
}
